import React, { Component } from 'react'
import WhitePanel from '../../../UI/white-panel/whitePanel'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { setCurrentPlaylist, fetchSong, setCurrentSong, isPlayingInBackground, setMusicConfig } from '../../../action/musicAction'
import defaultImagePic from '../../../images/default_cover.jpg'
import { musicSongListColor } from '../../../JS/setColors'
import {
  setLoader, setGoHome
} from "../../../layout2.0/action/homeAction";
import { CMSPath } from "../../../config/constant";
import ConfirmaionPopup from '../../../layout2.0/UI/warningConfirmationPopup'
import { HashRouter, Redirect } from 'react-router-dom';
import MiniLoader from '../../../layout2.0/UI/MiniLoader';


class MusicList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      musicList: [],
      imageBaseUrl: `${CMSPath}/cmsData/musicApp/images/`,
      initalLoader: true
    }
  }

  componentDidMount() {
    musicSongListColor(this.props.menuColor);
    this.props.isPlayingInBackground(false);

    if (this.props.selectedPlaylist && this.props.selectedPlaylist.id) {
      this.props.fetchSong(`apps/songlist/fetch?id=${this.props.selectedPlaylist.id}`);
    }

    if(this.props.musicList.length == 0){
      this.setState({initalLoader: true});

      setTimeout(() => {
        this.setState({initalLoader: false});
      }, 10000);
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.genres != this.props.genres && this.props.genres.length > 0){
      this.setState({initalLoader: false});
    }

    if ((this.props.currentSong && (this.props.currentSong.id != (prevProps.currentSong && prevProps.currentSong.id)))) 
    {
      this.props.setCurrentPlaylist(this.props.selectedPlaylist);
    }
  }

  componentWillUnmount() {
    if(this.props.currentSong){
      this.props.isPlayingInBackground(true);
      this.props.fetchSong(`apps/songlist/fetch?id=${this.props.currentPlaylist.id}`);
    } else {
      this.props.setCurrentSong(null);
      this.props.setCurrentPlaylist(null);
    }
  }


  playNext = () => {
    const { shuffle } = this.props.musicConfig
    const { musicList, currentSong } = this.props;

    const currentIndex = musicList.findIndex((song) => song.id === (currentSong && currentSong.id));

    if (shuffle) {
      let randomIndex;
      do {
          randomIndex = Math.floor(Math.random() * musicList.length);
      } while (randomIndex === currentIndex);

      this.props.setCurrentSong({ ...musicList[randomIndex], playSong: true });
    } else {
      // Default mode: play the next song in the list
      const nextIndex = (currentIndex + 1) % musicList.length;
      this.props.setCurrentSong({ ...musicList[nextIndex], playSong: true });
    }
  };

  playPrevious = () => {
    const { musicList, currentSong } = this.props;

    if (!currentSong || musicList.length === 0) return;

    // Default behavior: go to the previous song
    const currentIndex = musicList.findIndex((song) => song.id === currentSong.id);
    const previousIndex = currentIndex > 0 ? currentIndex - 1 : musicList.length - 1;
    this.props.setCurrentSong({ ...musicList[previousIndex], playSong: true });
  };

  setPlay = (song) => {
    const { currentSong } = this.props;
    if (currentSong && song.id === currentSong.id) {
      this.props.setCurrentSong({ ...song, playSong: !currentSong.playSong });
    } else {
      if(!song || Object.keys(song).length == 0){
        this.props.setCurrentSong({ ...this.props.musicList[0], playSong: true });
      } else {
        this.props.setCurrentSong({ ...song, playSong: true });
      }
    }
  };

  // Shuffle button functionality
  toggleShuffle = () => {
    this.props.setMusicConfig({ shuffle: !this.props.musicConfig.shuffle })
  }

  // Toggle Repeat One mode
  toggleRepeatOne = () => {
    this.props.setMusicConfig({ repeatOne: !this.props.musicConfig.repeatOne })
  }


  render() {

    return (
      <>
        {
          <>
              <div className="music-player">
                <div className="music-title">Music Player</div>

                <div className="music-info">
                  <div className="music-info-container">

                    <div className="music-details">

                      <div class="music-album" style={{ background: `url(${(this.props.currentSong && this.props.currentSong.imgName) ? `${this.state.imageBaseUrl}${this.props.currentSong.imgName}` : ''}) center center no-repeat`, backgroundSize: "cover"}}>
                        <div class="playback-controls">
                          <button className="buton play-pause">
                            <i className={`fa fas ${this.props.currentSong && this.props.currentSong.playSong ? 'fa-pause' : 'fa-play'}`}
                              onClick={() => {this.props.currentSong ? this.setPlay(this.props.currentSong) : this.playNext()}}
                            ></i>
                          </button>
                        </div>
                      </div>

                      <div className="music-title">
                        {this.props.currentSong ? this.props.currentSong.title : ""}
                      </div>
                      <div className="music-artist">
                        {this.props.currentSong ? this.props.currentSong.artist : ""}
                      </div>
                      <div className="music-album-name">
                        {this.props.currentSong ? this.props.currentSong.album : ""}
                      </div>
                    </div>
                  </div>
                </div>

                {this.props.musicList.length > 0 && <div className="music-controls">

                  <div className="music-control-buttons">
                    <button className="buton previous" onClick={this.playPrevious}><i className="fa fas fa-step-backward"></i></button>

                    <div class="toggle-play">
                      <button className={`buton shuffle ${this.props.musicConfig.shuffle ? 'active' : ''}`} onClick={this.toggleShuffle}>
                        <i className="fa fas fa-random"></i>
                      </button>
                      <button className="buton repeat repeat-one" onClick={this.toggleRepeatOne}>
                        <i className={`fa fas fa-repeat ${this.props.musicConfig.repeatOne ? "active" : ""}`}></i>
                        {this.props.musicConfig.repeatOne && <span className="repeat">1</span>}
                      </button>
                    </div>

                    <button className="buton next" onClick={this.playNext}><i className="fa fas fa-step-forward"></i></button>
                  </div>

                </div>}

              {this.props.musicList.length > 0 ? (
                <div className="playlist">
                  <div className="playlist-container">
                    {this.props.musicList.map(iterator => (
                      <div className="music-row" key={iterator.id} onClick={() => this.setPlay(iterator)}>
                        <div className="play-icon">
                          <i className={`fa fas ${this.props.currentSong && iterator.id === this.props.currentSong.id && this.props.currentSong.playSong ? 'fa-pause' : 'fa-play'}`}></i>
                        </div>
                        <div className="music-name">{iterator.title}</div>
                        <div className="music-duration">{iterator.palyingTimeInMin}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : this.state.initalLoader ? <MiniLoader /> : (
                <div className="music-player">
                  <h1>No songs available at this moment</h1>
                </div>
              )}

              <a onClick={() => this.props.handleGoBack()}>Go to playlist</a>
              </div>
          </>
        }
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    musicList: state.store.music.musicList,
    genres: state.store.music.musicGenres.genres,
    stringConst: state.store.home.stringConst,
    currentPlaylist: state.store.music.currentPlaylist,
    imageBaseUrl: state.store.music.musicGenres.imageBaseUrl,
    songBaseUrl: state.store.music.musicGenres.songBaseUrl,
    menuColor: state.store.home.MenuColor,
    isLoading: state.store.music.isLoading,
    currentSong: state.store.music.currentSong,
    musicConfig: state.store.music.musicConfig,
    isPlayInBackground: state.store.music.isPlayingInBackground,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
  }
}

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentSong: (song) => dispatch({ type: 'Music_Set_Current_Song', payload: song }),
// });

export default connect(
  mapStateToProps,
  {
    setCurrentPlaylist,
    fetchSong,
    setMusicConfig,
    setLoader,
    setCurrentSong,
    setGoHome,
    isPlayingInBackground
  }
)(MusicList);